import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalPostOfficeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_post_office"}/>
}
